import { IHeading, ITileHeader, STATUS_INDICATOR_STATUSES } from '@belong/types';
import { Entry } from 'contentful';
import { FImage } from '../image.factory';
import { FRichText } from '../richText.factory';
import type { Document } from '@contentful/rich-text-types';

export interface IEntryTileHeader {
  key: string;
  a11yTitle?: string;
  a11yPrefixStatusIndicator?: string;
  additionalInfo?: string | Document;
  headingVariant?: IHeading['variant'];
  image?: Entry<any>;
  statusIndicator?: STATUS_INDICATOR_STATUSES;
  subtitle?: string;
  title: string;
  value?: string;
}

export const FMoleculeTileHeader = (data: Entry<IEntryTileHeader>): ITileHeader => {
  const { image, additionalInfo, key, ...otherFields } = data.fields;

  let additionalInfoContent: ITileHeader['additionalInfo'];
  if (additionalInfo) {
    additionalInfoContent = typeof additionalInfo === 'string' ? additionalInfo : FRichText(additionalInfo);
  }

  return {
    image: image && FImage(image),
    additionalInfo: additionalInfoContent,
    ...otherFields
  };
};
